import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import JokoakNavbar from '../aurrera-jokoak/JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import GorbeaPronosticosDetailModal from './GorbeaPronosticosDetailModal';
import { normalizeSearchText } from '../../common/utils/normalize';
export default class GorbeaPronosticosPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasonParam", '');
    _defineProperty(this, "loading", true);
    _defineProperty(this, "isConfidential", false);
    _defineProperty(this, "fechaCierre", null);
    _defineProperty(this, "rivals", []);
    _defineProperty(this, "votes", []);
    _defineProperty(this, "players", []);
    // Sorting state
    _defineProperty(this, "sortBy", 'average');
    _defineProperty(this, "sortOrder", 'asc');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.seasonParam = m.route.param('season') || '2025-2026';
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.isConfidential = false;
    const pSeasons = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    });
    const pRivals = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals?season=".concat(this.seasonParam)
    });
    const pVotes = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-votes',
      params: {
        season: this.seasonParam
      }
    });
    const pPlayers = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players'
    }).catch(() => null);
    Promise.all([pSeasons, pRivals, pVotes, pPlayers]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 4),
        seasonsResp = _ref2[0],
        rivalsResp = _ref2[1],
        votesResp = _ref2[2],
        playersResp = _ref2[3];
      const seasons = app.store.pushPayload(seasonsResp) || [];
      const currentSeason = seasons.find(s => s.name().replace('/', '-') === this.seasonParam);
      if (currentSeason) {
        const dateStr = currentSeason.attribute('fechaCierreVotacionesPastorGorbea');
        this.fechaCierre = dateStr ? new Date(dateStr) : null;
      } else {
        this.fechaCierre = null;
      }
      const allRivals = app.store.pushPayload(rivalsResp) || [];
      this.rivals = allRivals.filter(r => r.attribute('division') === '1ª');
      this.votes = app.store.pushPayload(votesResp) || [];
      if (playersResp) {
        const allPlayers = app.store.pushPayload(playersResp) || [];
        this.players = allPlayers.filter(p => typeof p.isActive === 'function' ? p.isActive() !== false : true);
      }
      this.loading = false;
      m.redraw();
    }).catch(err => {
      // Check if the failure is due to permission denied (votes are still confidential)
      if (err && (err.status === 403 || err.status === 401)) {
        this.isConfidential = true;

        // Still load the seasons and rivals to display layout
        const pSeasons = app.request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
        });
        const pRivals = app.request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals?season=".concat(this.seasonParam)
        });
        Promise.all([pSeasons, pRivals]).then(_ref3 => {
          let _ref4 = _slicedToArray(_ref3, 2),
            seasonsResp = _ref4[0],
            rivalsResp = _ref4[1];
          const seasons = app.store.pushPayload(seasonsResp) || [];
          const currentSeason = seasons.find(s => s.name().replace('/', '-') === this.seasonParam);
          if (currentSeason) {
            const dateStr = currentSeason.attribute('fechaCierreVotacionesPastorGorbea');
            this.fechaCierre = dateStr ? new Date(dateStr) : null;
          }
          const allRivals = app.store.pushPayload(rivalsResp) || [];
          this.rivals = allRivals.filter(r => r.attribute('division') === '1ª');
          this.loading = false;
          m.redraw();
        }).catch(() => {
          this.loading = false;
          m.redraw();
        });
      } else {
        this.loading = false;
        m.redraw();
      }
    });
  }
  toggleSort(field) {
    if (this.sortBy === field) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortBy = field;
      this.sortOrder = field === 'average' ? 'asc' : 'asc'; // Ascending average is 1º to 20º
    }
    m.redraw();
  }
  showTeamDetail(team) {
    app.modal.show(GorbeaPronosticosDetailModal, {
      type: 'team',
      team: team,
      votes: this.votes
    });
  }
  showQuestionDetail(questionKey, questionLabel) {
    app.modal.show(GorbeaPronosticosDetailModal, {
      type: 'question',
      questionKey: questionKey,
      questionLabel: questionLabel,
      votes: this.votes,
      rivals: this.rivals,
      players: this.players
    });
  }

  // Helper to calculate top 3 positions for a team
  getTeamTop3Positions(teamId) {
    const counts = {};
    for (let i = 1; i <= 20; i++) {
      counts[i] = 0;
    }
    let totalVotesForTeam = 0;
    this.votes.forEach(vote => {
      if (!vote.attribute('classification')) return;
      const classification = vote.attribute('classification') || [];
      const posIndex = classification.indexOf(String(teamId));
      if (posIndex !== -1) {
        counts[posIndex + 1]++;
        totalVotesForTeam++;
      }
    });
    if (totalVotesForTeam === 0) return [];
    return Object.keys(counts).map(Number).map(pos => ({
      pos: pos,
      count: counts[pos]
    })).filter(item => item.count > 0).sort((a, b) => b.count - a.count || a.pos - b.pos) // Sort by count desc, then position asc
    .slice(0, 3);
  }

  // Helper to calculate average position for a team
  getTeamAveragePosition(teamId) {
    let sum = 0;
    let count = 0;
    this.votes.forEach(vote => {
      if (!vote.attribute('classification')) return;
      const classification = vote.attribute('classification') || [];
      const posIndex = classification.indexOf(String(teamId));
      if (posIndex !== -1) {
        sum += posIndex + 1;
        count++;
      }
    });
    return count > 0 ? sum / count : null;
  }

  // Helper to calculate summary counts for other questions
  getQuestionAnswerCounts(questionKey) {
    const counts = {};
    this.votes.forEach(vote => {
      const val = vote.attribute(questionKey);
      if (val !== undefined && val !== null && String(val).trim() !== '') {
        const answerStr = String(val).trim();
        counts[answerStr] = (counts[answerStr] || 0) + 1;
      }
    });
    return Object.keys(counts).map(answer => ({
      answer: answer,
      count: counts[answer]
    })).sort((a, b) => b.count - a.count);
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const season = this.seasonParam || '2025-2026';
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaUrl = isReal ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
    const gorbeaLabel = isReal ? 'Txindoki' : 'Gorbea';
    const renderAnswerThumbnail = answer => {
      if (!answer) return null;
      const cleanAnswer = normalizeSearchText(answer);

      // 1. Try to find matching rival (team)
      const matchingRival = this.rivals.find(r => {
        const rName = normalizeSearchText(r.attribute('name'));
        return cleanAnswer === rName || cleanAnswer.includes(rName) || rName.includes(cleanAnswer);
      });
      if (matchingRival && matchingRival.escudo()) {
        return m("img", {
          src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(matchingRival.escudo()),
          alt: answer,
          style: "width: 18px; height: 18px; object-fit: contain; flex-shrink: 0;"
        });
      }

      // 2. Try to find matching player
      const matchingPlayer = this.players.find(p => {
        if (String(p.id()) === cleanAnswer) return true;
        const pName = normalizeSearchText(p.name());
        if (cleanAnswer === pName || cleanAnswer.includes(pName) || pName.includes(cleanAnswer)) return true;
        const aliases = (p.aliases() || '').split(',').map(a => normalizeSearchText(a)).filter(Boolean);
        return aliases.some(a => a && (cleanAnswer === a || cleanAnswer.includes(a) || a.includes(cleanAnswer)));
      });
      if (matchingPlayer && matchingPlayer.photoUrl()) {
        return m("img", {
          src: matchingPlayer.photoUrl(),
          alt: answer,
          style: "width: 18px; height: 18px; border-radius: 50%; object-fit: cover; flex-shrink: 0; border: 1px solid rgba(0,0,0,0.1);"
        });
      }
      return null;
    };

    // Calculate and sort rivals list
    const processedRivals = this.rivals.map(rival => {
      const avg = this.getTeamAveragePosition(String(rival.id()));
      const top3 = this.getTeamTop3Positions(String(rival.id()));
      return {
        rival: rival,
        name: rival.attribute('name') || '',
        average: avg !== null ? avg : 99,
        // default low rank if no votes
        top3: top3
      };
    });
    processedRivals.sort((a, b) => {
      if (this.sortBy === 'name') {
        return this.sortOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
      } else {
        return this.sortOrder === 'asc' ? a.average - b.average : b.average - a.average;
      }
    });

    // Other questions config
    const questions = [{
      key: 'maxGoleadorLiga',
      label: 'Máximo Goleador Liga'
    }, {
      key: 'maxGoleadorTotal',
      label: 'Máximo Goleador Total'
    }, {
      key: 'maxAsistenteLiga',
      label: 'Máximo Asistente Liga'
    }, {
      key: 'maxAsistenteTotal',
      label: 'Máximo Asistente Total'
    }, {
      key: 'resultadoCopa',
      label: 'Resultado Copa del Rey'
    }, {
      key: 'porteriasCero',
      label: 'Porterías a Cero en Liga'
    }, {
      key: 'goleadasFavor',
      label: 'Goleadas a Favor en Liga'
    }, {
      key: 'goleadasContra',
      label: 'Goleadas en Contra en Liga'
    }];
    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Apuestas ".concat(gorbeaLabel)
    }), m("h2", {
      className: "BolillaPage-Title"
    }, "Trofeo Pastor del ", gorbeaLabel), m(JokoakNavbar, null), m("div", {
      className: "JokoakSubmenu"
    }, m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/clasificacion"),
      className: "JokoakSubmenu-link"
    }, "\uD83C\uDFC6 Clasificaci\xF3n"), this.fechaCierre && m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticar"),
      className: "JokoakSubmenu-link"
    }, "\u26F0\uFE0F Pronosticar"), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticos"),
      className: "JokoakSubmenu-link active"
    }, "\uD83D\uDD2E Apuestas de foreros")), this.isConfidential ? m("div", {
      className: "ActiveGameSection BolillaNoActiveGame"
    }, m("span", {
      style: "font-size: 3em; display: block; margin-bottom: 15px;"
    }, "\uD83D\uDD12"), m("h3", {
      style: "font-weight: 800; margin-bottom: 10px;"
    }, "Apuestas Confidenciales"), m("p", {
      style: "max-width: 500px; margin: 0 auto 20px auto;"
    }, "Las apuestas y pron\xF3sticos de los foreros son secretos y se revelar\xE1n autom\xE1ticamente una vez que se cierre el plazo de votaci\xF3n."), this.fechaCierre && m("div", {
      style: "display: inline-block; background: var(--control-bg); padding: 8px 16px; border-radius: 8px; font-weight: bold; font-size: 13px;"
    }, "Plazo de votaci\xF3n hasta: ", this.fechaCierre.toLocaleString())) : this.votes.length === 0 ? m("div", {
      className: "ActiveGameSection BolillaNoActiveGame"
    }, m("span", {
      style: "font-size: 3em;"
    }, "\uD83D\uDD2E"), m("h3", {
      style: "font-weight: 800; margin-top: 15px;"
    }, "No hay apuestas registradas"), m("p", null, "A\xFAn nadie ha realizado pron\xF3sticos para esta temporada.")) : m("div", {
      className: "GorbeaPronosticos-Content",
      style: "display: flex; flex-direction: column; gap: 30px;"
    }, m("div", {
      className: "GorbeaPronosticos-card"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 10px;"
    }, m("h3", {
      style: "font-weight: 800; font-size: 1.3em; margin: 0;"
    }, "\uD83D\uDD2E Tendencia de Posiciones de los Equipos"), m("div", {
      style: "font-size: 12px; color: var(--muted-color);"
    }, "Total apuestas: ", this.votes.length)), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", {
      style: "cursor: pointer; user-select: none;",
      onclick: () => this.toggleSort('name')
    }, "Equipo ", this.sortBy === 'name' ? this.sortOrder === 'asc' ? '🔼' : '🔽' : ''), m("th", {
      className: "center",
      style: "cursor: pointer; user-select: none;",
      onclick: () => this.toggleSort('average')
    }, "Posici\xF3n Media ", this.sortBy === 'average' ? this.sortOrder === 'asc' ? '🔼' : '🔽' : ''), m("th", {
      className: "hide-mobile"
    }, "3 Puestos M\xE1s Repetidos"), m("th", {
      className: "center"
    }, "Detalles"))), m("tbody", null, processedRivals.map(item => {
      const hasAvg = item.average !== 99;
      return m("tr", null, m("td", null, m("div", {
        style: "display: flex; align-items: center; gap: 10px; font-weight: bold;"
      }, item.rival.escudo() && m("img", {
        src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(item.rival.escudo()),
        alt: item.name,
        style: "width: 24px; height: 24px; object-fit: contain;"
      }), m("span", null, item.name))), m("td", {
        className: "center bold",
        style: "font-size: 14px; color: var(--primary-color);"
      }, hasAvg ? "".concat(item.average.toFixed(1), "\xBA") : '-'), m("td", {
        className: "hide-mobile"
      }, m("div", {
        style: "display: flex; gap: 8px; flex-wrap: wrap;"
      }, item.top3.length === 0 ? m("span", {
        style: "color: var(--muted-color); font-size: 12px;"
      }, "Sin datos") : item.top3.map((posInfo, index) => {
        const opacity = 1 - index * 0.2;
        return m("span", {
          style: "background: rgba(238, 37, 35, ".concat(opacity * 0.15, "); color: var(--primary-color); border: 1px solid rgba(238, 37, 35, ").concat(opacity * 0.3, "); padding: 3px 8px; border-radius: 6px; font-size: 12px; font-weight: bold;")
        }, posInfo.pos, "\xBA (", posInfo.count, " ", posInfo.count === 1 ? 'voto' : 'votos', ")");
      }))), m("td", {
        className: "center"
      }, m(Button, {
        className: "Button Button--link",
        onclick: () => this.showTeamDetail(item.rival)
      }, "Ver m\xE1s")));
    }))))), m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: 20px;"
    }, questions.map(q => {
      const counts = this.getQuestionAnswerCounts(q.key);
      return m("div", {
        className: "GorbeaPronosticos-card",
        style: "display: flex; flex-direction: column; justify-content: space-between;"
      }, m("div", null, m("div", {
        style: "display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 15px;"
      }, m("h4", {
        style: "font-weight: 800; font-size: 1.1em; margin: 0; padding-right: 10px;"
      }, q.label), m(Button, {
        className: "Button Button--link",
        style: "font-size: 11px; padding: 0;",
        onclick: () => this.showQuestionDetail(q.key, q.label)
      }, "Detalle")), m("div", {
        style: "display: flex; flex-direction: column; gap: 8px;"
      }, counts.length === 0 ? m("div", {
        style: "color: var(--muted-color); font-size: 12px; font-style: italic; padding: 10px 0;"
      }, "Sin respuestas") : counts.map((item, idx) => {
        // Percentage of total votes for this question
        const totalAnswers = counts.reduce((acc, curr) => acc + curr.count, 0);
        const pct = (item.count / totalAnswers * 100).toFixed(0);
        return m("div", {
          style: "display: flex; flex-direction: column; gap: 2px;"
        }, m("div", {
          style: "display: flex; justify-content: space-between; font-size: 13px;"
        }, m("span", {
          style: "font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 75%; display: flex; align-items: center; gap: 6px;"
        }, renderAnswerThumbnail(item.answer), (() => {
          const cleanAnswer = normalizeSearchText(String(item.answer));
          const matchingPlayer = this.players.find(p => {
            if (String(p.id()) === cleanAnswer) return true;
            const pName = normalizeSearchText(p.name());
            return cleanAnswer === pName || cleanAnswer.includes(pName) || pName.includes(cleanAnswer);
          });
          return m("span", null, matchingPlayer ? matchingPlayer.name() : item.answer);
        })()), m("span", {
          style: "font-weight: bold; color: var(--muted-color); font-size: 12px;"
        }, item.count, " ", item.count === 1 ? 'voto' : 'votos', " (", pct, "%)")), m("div", {
          style: "background: var(--control-bg); height: 6px; border-radius: 3px; overflow: hidden; width: 100%;"
        }, m("div", {
          style: "background: var(--primary-color); height: 100%; width: ".concat(pct, "%; border-radius: 3px;")
        })));
      }))));
    })))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/GorbeaPronosticosPage', GorbeaPronosticosPage);